module.exports = __webpack_public_path__ + "img/calendar3.2b8fa134.png";